import React, { useEffect, useState } from "react";
import CardQR from "../components/Card/CardQR";
import ModalQR from "../components/Modal/ModalGenerateQR";
import axios from "axios";
import { HEADER } from "../utils/Utils";
import ModalLoading from "../components/ModalLoading";
import ModalInformation from "../components/Modal/ModalInformation";
import _ from "lodash";

function GenerateFragment() {
  // data localstorage
  const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));
  const [dataOutletKartini] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet"))
  );
  const [dataQr, setDataQr] = useState([]);
  //   modal
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [showModalInformation, setShowModalInformation] = useState(false);
  const [modalInformation, setModalInformation] = useState({});

  // prepare modal
  const [inputQR, setInputQR] = useState({});
  const [showModalQR, setShowModalQR] = useState(false);
  const [modalQRDetails, setModalQRDetails] = useState({
    title: "Add QR",
    type: "Add",
  });

  useEffect(() => {
    GetDataQR();
  }, []);

  async function GetDataQR() {
    setShowModalLoading(true);
    try {
      let res_data_qr = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/v2/collection/dynamic/link/data?length=0&channel_id=${dataOutletKartini.channel_id}`,
        { headers: HEADER }
      );
      var pages = [];
      for (let i = 0; i < Math.ceil((res_data_qr.data.length - 1) / 10); i++) {
        pages.push(i + 1);
      }
      setDataQr(res_data_qr.data.data);
    } catch (error) {
      console.error(error);
    }
    setShowModalLoading(false);
  }

  const AddQR = async () => {
    setShowModalLoading(true);
    const LINK_WHATSAPP = `https://wa.me/6281112600700?text=%23${inputQR.question_trigger.replace(
      "#",
      ""
    )}*${inputQR.project_id}*${inputQR.akuisisi_id}`;
    let bodyData = {
      ...inputQR,
      dynamic_link_type_id: "ae7542b4-37a5-4e33-b2af-3a711a30371b",
      dynamic_link: LINK_WHATSAPP,
      dynamic_link_qr: `${process.env.REACT_APP_BASE_URL_GENERATOR_QR}/${btoa(
        LINK_WHATSAPP
      )}?base64=1`,
    };
    try {
      let res_qr = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/v2/collection/dynamic/link/data?akuisisi_id=${inputQR.akuisisi_id}&project_id=${inputQR.project_id}`,
        { headers: HEADER }
      );

      if (_.isEmpty(res_qr.data.data)) {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL_API}/dynamic/link`,
          bodyData,
          {
            headers: HEADER,
          }
        );
        GetDataQR();
      } else {
        setShowModalInformation(true);
        setModalInformation({
          type: "error",
          title: "Data already exists",
          detail:
            "Data Already Exists: The information you are trying to submit already exists in our records",
        });
      }
    } catch (error) {
      console.error(error);
      setShowModalInformation(true);
      setModalInformation({
        type: "error",
        title: "Unknown Error Occurred",
        detail:
          "We're sorry, but an unexpected error occurred, and we couldn't process your request. Our team has been notified of this issue. Please try again later or contact support if the problem persists. Thank you for your understanding.",
      });
    }
    setShowModalQR(false);
    setModalQRDetails({});
    setInputQR({});
    setShowModalLoading(false);
  };
  const EditQR = () => {};

  return (
    <div className="space-y-3">
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <ModalInformation
        showModal={showModalInformation}
        setShowModal={setShowModalInformation}
        type={modalInformation.type ?? ""}
        title={modalInformation.title ?? ""}
        detail={modalInformation.detail ?? ""}
      />
      <ModalQR
        modalQRDetails={modalQRDetails}
        showModal={showModalQR}
        setShowModal={setShowModalQR}
        inputQR={inputQR}
        setInputQR={setInputQR}
        functionAdd={AddQR}
        functionEdit={EditQR}
        dataOutletKartini={dataOutletKartini}
      />
      <div className="flex justify-between items-center">
        <h2 className="font-medium text-gray-700">QR List</h2>
        <button
          className="btn-sm bg-[#4CA6F8] text-white"
          onClick={(e) => {
            setShowModalQR(true);
            setModalQRDetails({
              title: "Add QR",
              type: "Add",
            });
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
            />
          </svg>
          <span className="ml-2">Generate QR</span>
        </button>
      </div>
      <div className=" overflow-y-scroll mt-4">
        <div className="space-y-3">
          {dataQr.map((detail, i) => {
            return (
              <CardQR
                key={i}
                data={detail}
                enActionEdit={user.user_type === "member"}
                enActionDelete={user.user_type === "member"}
                isDisable={false}

                // editFunction={ShowEditModal}
                // deleteFunction={ShowDeleteModal}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default GenerateFragment;
